import sdl from '@jds/react-generated-sdl/JDSInputDate';
import type { JDSInputDateProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, InputDateProps } from '../logic';

const Component = (props: InputDateProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    disabled = false,
    error = false,
    ddError = false,
    mmError = false,
    yyError = false,
    showCalendar = true,
    dateAriaLabel = 'Insert day',
    monthAriaLabel = 'Insert month',
    yearAriaLabel = 'Insert year',
    datepickerAriaLabel = 'Launch datepicker',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      disabled,
      error,
      ddError,
      mmError,
      yyError,
      showCalendar,
      dateAriaLabel,
      monthAriaLabel,
      yearAriaLabel,
      datepickerAriaLabel,
      ...rest
    },
    'JDSInputDate',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputDate = withLogic(Component) as React.FC<InputDateProps> & {
  slotName?: string;
};

InputDate.displayName = 'InputDate';
InputDate.slotName = 'jds_input_date';

export { InputDate, type JDSInputDateProps };
